<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmt sgc-1" id="heading_id_2">Contents</h1>
<p class="toc" id="pre1"><a href="#/Text/Preface#pre_1">Preface by Amy Scholder, editorial director of the Feminist Press</a></p>
<p class="toc" id="ch1"><a href="#/Text/Chapter1#ch_1">Virgin Mary, Put Putin Away (Punk Prayer)</a></p>
<p class="toc" id="ch2"><a href="#/Text/Chapter2#ch_2">Pussy Riot: Art or Politics?</a></p>
<p class="toc" id="ch3"><a href="#/Text/Chapter3#ch_3">Letter by Masha in Prison</a></p>
<p class="toc" id="ch4"><span href="#/Text/Chapter4#ch_4" title="Link target outside of Sample">Letters by Nadya in Prison</span></p>
<p class="toc" id="ch5"><span href="#/Text/Chapter5#ch_5" title="Link target outside of Sample">Death to Prison, Freedom to Protest</span></p>
<p class="toc" id="ch6"><span href="#/Text/Chapter6#ch_6" title="Link target outside of Sample">Letter to Patriarch Kirill</span></p>
<p class="toc" id="ch7"><span href="#/Text/Chapter7#ch_7" title="Link target outside of Sample">Kropotkin-Vodka</span></p>
<p class="toc" id="ch8"><span href="#/Text/Chapter8#ch_8" title="Link target outside of Sample">Letter to President Medvedev</span></p>
<p class="toc" id="ch9"><span href="#/Text/Chapter9#ch_9" title="Link target outside of Sample">Putin Has Pissed Himself</span></p>
<p class="toc" id="ch10"><span href="#/Text/Chapter10#ch_10" title="Link target outside of Sample">Opening Courtroom Statement by Masha</span></p>
<p class="toc" id="ch11"><span href="#/Text/Chapter11#ch_11" title="Link target outside of Sample">Opening Courtroom Statement by Nadya</span></p>
<p class="toc" id="ch12"><span href="#/Text/Chapter12#ch_12" title="Link target outside of Sample">Raze the Pavement</span></p>
<p class="toc" id="ch13"><span href="#/Text/Chapter13#ch_13" title="Link target outside of Sample">Excerpts from the Court Transcript</span></p>
<p class="toc" id="ch14"><span href="#/Text/Chapter14#ch_14" title="Link target outside of Sample">Closing Statement by Defense Attorney Violetta Volkova</span></p>
<p class="toc" id="ch15"><span href="#/Text/Chapter15#ch_15" title="Link target outside of Sample">Closing Statement by Defense Attorney Mark Feygin</span></p>
<p class="toc" id="ch16"><span href="#/Text/Chapter16#ch_16" title="Link target outside of Sample">Closing Statement by Defense Attorney Nikolay Polozov</span></p>
<p class="toc" id="ch17"><span href="#/Text/Chapter17#ch_17" title="Link target outside of Sample">Closing Courtroom Statement by Katya</span></p>
<p class="toc" id="ch18"><span href="#/Text/Chapter18#ch_18" title="Link target outside of Sample">Closing Courtroom Statement by Nadya</span></p>
<p class="toc" id="ch19"><span href="#/Text/Chapter19#ch_19" title="Link target outside of Sample">Closing Courtroom Statement by Masha</span></p>
<p class="toc" id="ch20"><span href="#/Text/Chapter20#ch_20" title="Link target outside of Sample">Three Poems by Masha</span></p>
<p class="toc" id="ch21"><span href="#/Text/Chapter21#ch_21" title="Link target outside of Sample">Tributes to Pussy Riot: Yoko Ono, Johanna Fateman, JD Samson, Eileen Myles, Justin Vivian Bond, and Karen Finley</span></p>
<p class="toc" id="ch23"><span href="#/Text/Chapter23#ch_23" title="Link target outside of Sample">About the Author—Pussy Riot</span></p>
<p class="toc" id="ch24"><span href="#/Text/Chapter24#ch_24" title="Link target outside of Sample">Also Available from the Feminist Press</span></p>
<p class="toc" id="ch25"><span href="#/Text/Chapter25#ch_25" title="Link target outside of Sample">About the Feminist Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?32b0cf84